(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swish/swish.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swish/swish.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Form = svs.ui.reactForm.Form;
const logger = svs.accountservicesReact.deposit.swish.logger;
const _React = React,
  useEffect = _React.useEffect;
const _svs$accountservicesR = svs.accountservicesReact.deposit.depositShared,
  OnboardingDepositAmountInfo = _svs$accountservicesR.OnboardingDepositAmountInfo,
  DepositButton = _svs$accountservicesR.DepositButton,
  DepositInput = _svs$accountservicesR.DepositInput,
  useSuccessCleanup = _svs$accountservicesR.useSuccessCleanup;
const _svs$accountservicesR2 = svs.accountservicesReact.deposit.swish.components,
  DepositCredentialsWrapper = _svs$accountservicesR2.DepositCredentialsWrapper,
  DepositInfo = _svs$accountservicesR2.DepositInfo;
const swishService = svs.accountservicesReact.deposit.services.SwishService;
const _svs$accountservicesR3 = svs.accountservicesReact.deposit.store.deposit.actions,
  amountChangeAction = _svs$accountservicesR3.amountChangeAction,
  returnUrlChange = _svs$accountservicesR3.returnUrlChange,
  updateSpendLimitRemainingAction = _svs$accountservicesR3.updateSpendLimitRemainingAction;
const cellphoneChangeAction = svs.accountservicesReact.deposit.store.swish.actions.cellphoneChangeAction;
const _svs$accountservicesR4 = svs.accountservicesReact.deposit.dialogs.swishDialogs,
  showSwishTransferMobile = _svs$accountservicesR4.showSwishTransferMobile,
  showSwishTransferDesktop = _svs$accountservicesR4.showSwishTransferDesktop,
  showCancelSwish = _svs$accountservicesR4.showCancelSwish,
  showTransferError = _svs$accountservicesR4.showTransferError,
  showDepositSuccess = _svs$accountservicesR4.showDepositSuccess,
  showCellPhoneVerifiedDialog = _svs$accountservicesR4.showCellPhoneVerifiedDialog;
const paymentTypes = svs.accountservicesReact.deposit.constants.paymentTypes;
const _svs$accountservicesR5 = svs.accountservicesReact.deposit.helpers.sharedHelpers,
  hasInstantPayAmount = _svs$accountservicesR5.hasInstantPayAmount,
  navigateOnPayTrue = _svs$accountservicesR5.navigateOnPayTrue;
const swishstatus = svs.accountservicesReact.deposit.constants.swishstatus;
const Swish = _ref => {
  let _ref$hasNoProfileLink = _ref.hasNoProfileLinkSwish,
    hasNoProfileLinkSwish = _ref$hasNoProfileLink === void 0 ? false : _ref$hasNoProfileLink,
    handleSelect = _ref.handleSelect,
    _ref$isPlayerRegistra = _ref.isPlayerRegistration,
    isPlayerRegistration = _ref$isPlayerRegistra === void 0 ? false : _ref$isPlayerRegistra,
    setIsCheckBlock = _ref.setIsCheckBlock;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    submitDisabled = _React$useState2[0],
    setSubmitDisabled = _React$useState2[1];
  const dispatch = ReactRedux.useDispatch();
  const amountRedux = ReactRedux.useSelector(state => state.deposit.amount);
  const cellPhone = ReactRedux.useSelector(state => state.swish.cellPhone);
  const newCellPhone = ReactRedux.useSelector(state => state.swish.newCellPhone);
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  const instantPay = ReactRedux.useSelector(state => state.deposit.instantPay);
  const maxLimitLeft = ReactRedux.useSelector(state => {
    var _state$deposit$maxLim;
    return (_state$deposit$maxLim = state.deposit.maxLimits) === null || _state$deposit$maxLim === void 0 ? void 0 : _state$deposit$maxLim.spendLimitRemaining;
  });
  const successCleanup = useSuccessCleanup();
  const handleSwishCommunicationSettings = async () => {
    const hasCustomerCellPhoneBeforeSwishDeposit = (cellPhone === null || cellPhone === void 0 ? void 0 : cellPhone.length) > 3;
    await swishService.swishHandleCommunicationSettingsAsync(hasCustomerCellPhoneBeforeSwishDeposit);
    dispatch(cellphoneChangeAction(newCellPhone));
  };
  const handleCellPhoneVerified = async () => {
    const isNewCellphoneNumber = (cellPhone === null || cellPhone === void 0 ? void 0 : cellPhone.length) <= 3;
    await showCellPhoneVerifiedDialog(isNewCellphoneNumber, hasNoProfileLinkSwish);
  };

  const getQueryParams = (param, url) => {
    const href = url;
    const reg = new RegExp("[?&]".concat(param, "=([^&#]*)"), 'i');
    const queryString = reg.exec(href);
    return queryString ? queryString[1] : null;
  };

  const clearUrlParam = paramToClear => {
    svs.utils.url.refreshQueryString();
    const currentParamToClear = svs.utils.url.queryString[paramToClear];
    if (currentParamToClear) {
      let targetString = '';
      let delim = '?';
      for (const param in svs.utils.url.queryString) {
        if (param !== paramToClear) {
          targetString = "".concat(targetString).concat(delim).concat(param, "=").concat(encodeURIComponent(svs.utils.url.queryString[param]));
          delim = '&';
        }
      }
      window.history.replaceState({}, '', "".concat(window.location.pathname).concat(targetString));
      svs.utils.url.refreshQueryString();
    }
  };
  const serializeSwishData = data => {
    const _data$amount = data.amount,
      amount = _data$amount === void 0 ? '' : _data$amount,
      _data$transactionId = data.transactionId,
      transactionId = _data$transactionId === void 0 ? '' : _data$transactionId,
      _data$cellphone = data.cellphone,
      cellphone = _data$cellphone === void 0 ? '' : _data$cellphone,
      _data$returnUrl = data.returnUrl,
      returnUrl = _data$returnUrl === void 0 ? '' : _data$returnUrl;
    return "".concat(transactionId, "|").concat(amount, "|").concat(cellphone, "|").concat(returnUrl);
  };
  const encodeSwishData = stringToEncode => {
    const b64WithoutPadding = window.btoa(stringToEncode);
    return encodeURIComponent(b64WithoutPadding);
  };
  const handleIosSafari = (responseData, depositData) => {
    if (!svs.core.config.data.svsconfig.isNativeApp && svs.core.detect.os.iOS() && svs.core.detect.formfactor.mobile() && navigator.userAgent.toLowerCase().indexOf('safari') > -1) {
      svs.utils.url.refreshQueryString();
      const serialize = {
        amount: depositData.amount,
        transactionId: responseData.transactionId,
        cellPhone: depositData.cellPhone,
        returnUrl
      };

      clearUrlParam('returnUrl');

      let targetPath = svs.utils.url.currentPathEncodedParams();
      targetPath = svs.utils.url.updateQueryStringParameter(targetPath, 'sdd', encodeSwishData(serializeSwishData(serialize)));
      window.history.replaceState({}, '', targetPath);
    }
  };
  const handleSwishDeposit = async swishResume => {
    let depositData;
    const hasCellPhoneChangeBeforeSwishDeposit = (newCellPhone === null || newCellPhone === void 0 ? void 0 : newCellPhone.length) > 3 && newCellPhone !== cellPhone;
    try {
      if (!swishResume) {
        const cellPhoneUsed = (newCellPhone === null || newCellPhone === void 0 ? void 0 : newCellPhone.length) > 3 ? newCellPhone : cellPhone;
        depositData = {
          cellPhone: cellPhoneUsed,
          amount: amountRedux
        };
        setSubmitDisabled(true);
        const responseData = await swishService.executeSwishDepositAsync(depositData);
        logger.debug('**** init ok, responseData: ');
        logger.debug(_objectSpread(_objectSpread({}, responseData), {}, {
          accountBalance: 'hidden'
        }));
        handleIosSafari(responseData, depositData);
        const handleCancel = async () => {
          setSubmitDisabled(false);
          clearInterval(window.globalIntervalId);
          showCancelSwish();
          await svs.components.analytics.trackEvent({
            category: 'Deposits',
            action: 'Deposit Cancel BackButton',
            opt_label: 'Swish'
          });
        };
        if (svs.core.detect.formfactor.mobile()) {
          showSwishTransferMobile(handleCancel, responseData.paymentRequestToken);
        } else {
          showSwishTransferDesktop(handleCancel, depositData, hasCellPhoneChangeBeforeSwishDeposit);
        }
        depositData.transactionId = responseData.transactionId;
      } else {
        depositData = swishResume;
        if (depositData.returnUrl) {
          dispatch(returnUrlChange(depositData.returnUrl));
        }
      }

      const pollResponse = await swishService.pollSwishDepositAsync(depositData.transactionId, depositData.amount);
      svs.events.publish('/loader/hide');
      switch (pollResponse.status) {
        case swishstatus.OK:
          logger.debug('**** swish OK');
          if (hasCellPhoneChangeBeforeSwishDeposit) {
            await handleSwishCommunicationSettings(); 
            await handleCellPhoneVerified();
          }
          await successCleanup({
            amount: depositData.amount,
            accountBalance: pollResponse.accountBalance
          });
          if (navigateOnPayTrue(returnUrl)) {
            return;
          }
          dispatch(updateSpendLimitRemainingAction(depositData.amount));
          await showDepositSuccess({
            amount: depositData.amount,
            accountBalance: pollResponse.accountBalance,
            paymentType: paymentTypes.SWISH
          }, returnUrl);
          break;
        case swishstatus.ERROR_SWISH:
          logger.debug('**** swish ERROR_SWISH');
          await showTransferError(pollResponse.error, depositData.amount, handleSelect);
          break;
        case swishstatus.ERROR_INTERNAL:
          logger.debug('**** swish ERROR_INTERNAL');
          await showTransferError(pollResponse.error, depositData.amount, handleSelect);
          break;
        default:
          logger.debug('**** swish case default');
          await showTransferError();
          break;
      }
    } catch (err) {
      svs.events.publish('/loader/hide');
      if (err.code === 100037) {
        setIsCheckBlock(true);
      } else if ([50107, 50105].includes(err.code)) {
        await showTransferError(err, depositData.amount, handleSelect, maxLimitLeft);
      } else {
        await showTransferError(err, depositData.amount, handleSelect);
        logger.debug('TransferError SwishDeposit: ', err);
      }
    }
    setSubmitDisabled(false);
  };
  const handleSubmit = (e, isValid) => {
    e === null || e === void 0 || e.preventDefault();
    e === null || e === void 0 || e.stopPropagation();

    if (!isValid) {
      return;
    }
    handleSwishDeposit();
  };
  const decodeSwishData = data => window.atob(data);
  const checkSwishResume = () => {
    let swishDepositData = getQueryParams('sdd', location.href);
    if (swishDepositData) {
      svs.events.publish('/loader/show');
      swishDepositData = decodeSwishData(decodeURIComponent(swishDepositData));
      const split = swishDepositData.split('|');
      swishDepositData = null;
      const swishResume = {
        transactionId: split[0],
        amount: split[1],
        cellPhone: split[2],
        returnUrl: !split[3] || split[3] == 'null' || split[3] == 'undefined' ? returnUrl : decodeURIComponent(split[3])
      };
      logger.debug('Resuming pending transfer for iOS, data: ', JSON.stringify(swishResume));
      handleSwishDeposit(swishResume);
      svs.utils.url.refreshQueryString();
      const sdd = svs.utils.url.queryString.sdd;
      if (sdd) {
        clearUrlParam('sdd');
      }
    } else if (hasInstantPayAmount(instantPay)) {
      dispatch(amountChangeAction(instantPay === null || instantPay === void 0 ? void 0 : instantPay.amount));
    }
  };
  useEffect(() => {
    checkSwishResume();
  }, []);
  return React.createElement(Form, {
    method: "post",
    onSubmit: (e, _formData, isValid) => {
      handleSubmit(e, isValid);
    }
  }, !svs.core.detect.formfactor.mobile() && React.createElement(DepositCredentialsWrapper, null), React.createElement(DepositInput, null), isPlayerRegistration && React.createElement(OnboardingDepositAmountInfo, {
    depositAmount: amountRedux
  }), React.createElement(DepositButton, {
    isSubmitDisabled: submitDisabled
  }), React.createElement(DepositInfo, null));
};
svs.accountservicesReact.deposit.swish.Swish = Swish;

 })(window);